
export const GET_WEBHOOKS = 'GET_WEBHOOKS';
export const GET_WEBHOOKS_SUCCESS = 'GET_WEBHOOKS_SUCCESS';
export const GET_WEBHOOKS_FAILURE = 'GET_WEBHOOKS_FAILURE';


export const CREATE_WEBHOOK = 'CREATE_WEBHOOK';
export const CREATE_WEBHOOK_SUCCESS = 'CREATE_WEBHOOK_SUCCESS';
export const CREATE_WEBHOOK_FAILUE = 'CREATE_WEBHOOK_FAILUE';

export const EDIT_WEBHOOK = 'EDIT_WEBHOOK';
export const EDIT_WEBHOOK_SUCCESS = 'EDIT_WEBHOOK_SUCCESS';
export const EDIT_WEBHOOK_FAILURE = 'EDIT_WEBHOOK_FAILURE';

export const DELETE_WEBHOOK = 'DELETE_WEBHOOK';
export const DELETE_WEBHOOK_SUCCESS = 'DELETE_WEBHOOK_SUCCESS';
export const DELETE_WEBHOOK_FAILURE = 'DELETE_WEBHOOK_FAILURE';

export const LOADING = 'LOADING';
export const CLEAN_ERRORS = 'CLEAN_ERRORS';
